import { SVG } from '../SVG'

export const PlusOpenIcon = ({ style = {}, ...props }) => (
  <SVG
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    strokeWidth='3'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: 'var(--quaternary-text-color)', ...style }}
    {...props}
  >
    <rect x='1.5' y='1.5' width='19' height='19' rx='1.5' />
    <path d='M6.25 11H15.75' strokeLinecap='round' />
    <path d='M11 15.75L11 6.25' strokeLinecap='round' />
  </SVG>
)
